import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from '../../style'

import Container from '../../partials/Container'
import GroupForm from '../../partials/GroupForm'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('User', 'Auth', 'Config')
@observer
export class GroupCreate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        name: '',
        permissions: {}
      }
    }
  }

  onPermClick (e) {
    const name = e.currentTarget.dataset.name
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        permissions: {
          ...this.state.editor.permissions,
          [name]: !this.state.editor.permissions[name]
        }
      }
    })
  }

  onNameInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        name: e.target.value
      }
    })
  }

  onSaveClick (e) {
    e.preventDefault()
    console.log(this.state)
    this.props.User.postGroup(this.state.editor).then(() => this.goBack())
  }

  goBack (e) {
    return this.props.history.push(this.props.match.url.replace(`/new`, ''))
  }

  render () {
    return (
      <Container {...this.props}>
        <Row>
          <Col>
            <Row>
              <Col xs='12' lg='6'>
                <h2 className={css(style.headers.h2)}>Create Group</h2>
              </Col>
              <Col>
                <Row>
                  <Col />
                  <Col>
                    <span
                      onClick={this.onSaveClick.bind(this)}
                      className={css(style.buttons.button, style.buttons.red)}
                    >
                      Save
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <GroupForm
              theme={THEME_LIST[this.props.Config.theme]}
              editor={this.state.editor}
              group={this.state.editor}
              onPermClick={this.onPermClick.bind(this)}
              onNameInputChange={this.onNameInputChange.bind(this)}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default GroupCreate



// WEBPACK FOOTER //
// ./src/components/User/Group/Create/index.js